import { useQuery } from "@tanstack/react-query";
import { BusinessManagementApi } from "service/api/business-management.api";
import { QUERY_KEYS } from "service/constant/query-keys";
import { downloadFileByUrl } from "ultis/common";

export const useGetListBusiness = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_LIST, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusiness(params);
      return res.data;
    },
    ...options,
  });
};

export const useExportListBusiness = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_LIST_EXPORT, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.exportListBusiness(params);
      const linkFile = res.data?.data;
      if (linkFile) {
        downloadFileByUrl(linkFile);
      }
    },
    enabled: false,
    ...options,
  });
};

export const useGetListBusinessPhoneNumber = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_PHONE_NUMBER, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessPhoneNumber(
        params
      );
      return res.data;
    },
    ...options,
  });
};

export const useExportListBusinessPhoneNumber = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_PHONE_NUMBER_EXPORT, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.exportListBusinessPhoneNumber(
        params
      );
      const linkFile = res.data?.data;
      if (linkFile) {
        downloadFileByUrl(linkFile);
      }
    },
    enabled: false,
    ...options,
  });
};

export const useGetListBusinessUser = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_USER_LIST, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessUser(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useGetListBusinessExtension = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_EXTENSION_LIST, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessExtension(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useGetListBusinessReport = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_REPORT_LIST, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessReport(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useGetListBusinessReportType = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_REPORT_TYPE, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessReportType(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useGetListPbxType = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.BUSINESS_PBX_TYPE_LIST, params],
    queryFn: async () => {
      const res = await BusinessManagementApi.getListBusinessPbxType(params);
      return res.data;
    },
    ...options,
  });
};
